<template>
  <div class="common-file-card" @click.stop="() => {}">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <div class="mr-4">
          <document-icon :type="type" svgClasses="w-5 h-5"></document-icon>
        </div>
        <div>{{ file.name }}</div>
      </div>

      <feather-icon
        v-if="showDelete"
        svgClasses="h-5 w-5"
        icon="XIcon"
        class="close-button p-1 rounded cursor-pointer"
        @click.stop="_deleteFile(file.id)"
      ></feather-icon>
    </div>
  </div>
</template>

<script>
import DocumentIcon from "./DocumentIcon.vue"
import { ColorMixin, DocumentMixin } from "@/mixins";

export default {
  name: "M.CommonFileCard",
  components: { DocumentIcon },
  mixins: [ColorMixin, DocumentMixin],
  props: {
    file: {
      type: Object
    },
    deleteFile: {
      type: Function,
      default: () => {}
    },
    showDelete: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  computed: {
    type() {
      return this.getDocumentMimeKind(this.file.type);
    }
  },
  methods: {
    _deleteFile(id) {
      this.deleteFile(id);
    }
  }

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";

.common-file-card {
  padding: 4px 12px;
  background-color: $aisea-pure-white;
  color: $common-text-dark-gray;
  border: solid 1px $border-color1;
  border-radius: 6px;
  margin-bottom: 8px;

  .close-button {
    color: $icon-gray;
  }
}
</style>